import { render } from "./GetPlainDialog.vue?vue&type=template&id=66df982e&scoped=true"
import script from "./GetPlainDialog.vue?vue&type=script&lang=js"
export * from "./GetPlainDialog.vue?vue&type=script&lang=js"

import "./GetPlainDialog.vue?vue&type=style&index=0&id=66df982e&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66df982e"]])

export default __exports__